import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { MainComponentDetailTable } from './MainComponentDetailTable'
import { CreateMainComponentDialog } from './CreateMainComponentDialog'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { FC, ReactNode } from 'react'

interface MainComponentAddContainerProps {
  mainComponentTypeName: string
  componentTypeId: EntityId
  itemCount: number
  searchText?: string
  assignedCustomerId?: number
  searchField?: ReactNode
}
export const MainComponentAddContainer: FC<MainComponentAddContainerProps> = ({
  mainComponentTypeName,
  componentTypeId,
  itemCount,
  searchText,
  assignedCustomerId,
  searchField,
}) => {
  const { id: customerId, localityId, mooringId, positionId } = useParams()
  const { showDialog } = useDialogCtx()
  const onAdd = async () => {
    const added = await showDialog(
      CreateMainComponentDialog,
      {
        componentProps: {
          customerId: customerId as EntityId,
          mainComponentTypeName: mainComponentTypeName,
          componentTypeId: componentTypeId,
          searchText: searchText,
        },
      },
      undefined,
      true,
    )
    if (!added) return
  }

  return (
    <>
      <Box className="p-2 bg-white" borderRadius={2}>
        <MainComponentDetailTable
          customerId={customerId as EntityId}
          componentTypeId={componentTypeId as number}
          onClickMethod={onAdd}
          mainComponentTypeName={mainComponentTypeName}
          localityId={localityId as EntityId}
          mooringId={mooringId as EntityId}
          positionId={positionId as EntityId}
          itemCount={itemCount}
          searchText={searchText}
          assignedCustomerId={assignedCustomerId}
          searchField={searchField}
        />
      </Box>
    </>
  )
}
